import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { fetchReminderSuccess, onGetReminder, fetchGetReminderReceiversSuccess } from "../actions/Reminder";
import { ActionTypes } from "../../constants/ActionTypes";
import { fetchError } from "../actions/Common";
import { ShowError, ShowSuccess } from "../../helper/Alert";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";
import { IAddReminderParams } from "../../interfaces";

const getReminder = async (page: number | null, onlyApproval: boolean | null, searchText: string | null) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`reminder/getNotifications?page=${page}`);
}

const changeReminder = async (parameters: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post("reminder/changeNotificationStatus", parameters);
}

const addReminder = async (parameters: IAddReminderParams) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post("notify/addReminder", parameters);
}

const getReminderReceivers = async (parameters: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`notify/getReminderReceivers?letterCode=${parameters.letterCode}&searchText=`);
}

function* fetchReminderRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedReminder = yield call(getReminder, action.payload.page, action.payload.onlyApproval, action.payload.searchText);
        yield put(fetchReminderSuccess({
            append: action.payload.append,
            reminder: fetchedReminder.data
        }));
    } catch (error) {
        // return ShowError("", error);
    }
}

export function* fetchReminder() {
    yield takeEvery(ActionTypes.GET_REMINDER, fetchReminderRequest);
}

// change reminder
function* fetchChangeReminderRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(changeReminder, action.payload);
        ShowSuccess(messages["messages.operationWasSuccessful"], "");
        yield put(onGetReminder({ page: 0, onlyApproved: null, onlyforce: null, searchText: null, append: false, isNotify: false }));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchChangeReminder() {
    yield takeEvery(ActionTypes.CHANGE_REMINDER, fetchChangeReminderRequest);
}

function* fetchReminderReceiversRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedReminderReceivers = yield call(getReminderReceivers, action.payload);
        yield put(fetchGetReminderReceiversSuccess(fetchedReminderReceivers.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchReminderReceivers() {
    yield takeEvery(ActionTypes.GET_REMINDER_RECEIVERS, fetchReminderReceiversRequest);
}

function* fetchAddReminderRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(addReminder, action.payload);
        ShowSuccess(messages["messages.operationWasSuccessful"], "");

        // console.log("action", action)
        yield put(onGetReminder({ page: 0, onlyApproved: null, onlyforce: null, searchText: null, append: false, isNotify: false }));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchAddReminder() {
    yield takeEvery(ActionTypes.ADD_REMINDER, fetchAddReminderRequest);
}

export default function* rootSaga() {
    yield all([
        fork(fetchReminder),
        fork(fetchChangeReminder),
        fork(fetchReminderReceivers),
        fork(fetchAddReminder)
    ]);
}
